import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~common/react/CommonStyles';
import { truncated } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';

import { cssClass } from '../../style';

export namespace CollectionsDialogStyles {
  const cssPrefix: string = 'collections-dialog';
  export const ADD_TO_DIALOG_WIDTH = 500;
  export const COLLECTION_MARGIN = 12;
  export const COLLECTION_HEIGHT = 20;
  export const COLLECTION_ITEM_SCROLL_HEIGHT = COLLECTION_HEIGHT * (3/4);

  export const Spinner = cssClass(cssPrefix, 'spinner', {
    marginTop: '48px',
    marginBottom: '48px',
    textAlign: 'center'
  });

  export const ItemsToAdd = cssClass(cssPrefix, 'items-to-add', {
    marginBottom: CommonStyles.Sizes.MediumSpace,
  });

  export const ActionButtonsFlexContainer = cssClass(cssPrefix, 'action-buttons-flex-container', {
    display: 'flex',
    justifyContent: 'space-between',
  });

  export const CreateCollectionButton = cssClass(cssPrefix, 'create-collection-button', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    $nest: {
      '> *': {
        verticalAlign: 'middle'
      }
    }
  });

  const CollectionsListStylesShared: React.CSSProperties = {
    overflowY: 'auto',
    border: `1px solid ${TabStyles!.Colors!.L6}`,
  };

  export const CollectionListMaxHeight = 200;
  export const SearchBarHeight = 30;
  export const CollectionsList = cssClass(cssPrefix, 'collections-list', CollectionsListStylesShared, {
    maxHeight: CollectionListMaxHeight,
    position: 'relative',
  });

  export const CollectionsFilteringList = cssClass(cssPrefix, 'collections-filtering-list', CollectionsListStylesShared, {
    maxHeight: CollectionListMaxHeight + SearchBarHeight,
    $nest: {
      '& > [role="listbox"]': { position: 'relative' } // necessary for use of `position: absolute` in OwnerPrefix below, TFSID 1296677
    }
  });

  export const CreateCancelButtons = cssClass(cssPrefix, 'create-cancel-buttons', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  });

  export const NewBadge = cssClass(cssPrefix, 'new-badge', {
    background: CommonStyles.Colors.BadgeBlue,
    borderRadius: 2,
    color: CommonStyles.Colors.White,
    letterSpacing: '0.2px',
    textAlign: 'center',
    fontWeight: 'bold',
    marginLeft: 8
  });

  export const CollectionListItemContainer = cssClass(cssPrefix, 'collection-list-item-container', {
    display: 'flex',
    width: `100%`,
  });

  export const OwnerPrefix = cssClass(cssPrefix, 'owner-prefix', {
    color: 'transparent',
    position: 'absolute',
  });

  export const OwnerName = cssClass(cssPrefix, 'owner-name', truncated, {
    color: CommonStyles.Colors.Grey112,
    marginLeft: 8,
    width: '25%',
    textAlign: 'right',
  });

  export const CollectionListItemText = cssClass(cssPrefix, 'collection-list-item-text', truncated);
  export const CollectionName = cssClass(cssPrefix, 'collection-name', truncated, {
    display: 'flex',
    width: '75%',
  });

  export const GrantPermissionsDialogFooter = cssClass(cssPrefix, 'grant-permissions-dialog-footer', {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  });

  export const GrantPermissionsManagePermissionsButton = cssClass(cssPrefix, 'grant-permissions-manage-permissions-button', {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-beginning'
  });

  export const GrantPermissionsRightButtons = cssClass(cssPrefix, 'grant-permissions-right-buttons', {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-end'
  });
}
